import { UserDetailsType, UserSessionObjectType } from './types';
import { getBankOverallDetails, getClosingBalance } from './utils';
export const USERSESSIONOBJECT: UserSessionObjectType = {
  userId: null,
  accessToken: null,
  refreshToken: null,
  approvedConsentsAvailable: null,
  referenceId: null,
  accounts: null,
  templateType: null,
  pfmType: null,
  data: null,
};

export const setPfmType = (type: string) => {
  USERSESSIONOBJECT.pfmType = type;
};

export const getPfmType = () => {
  return USERSESSIONOBJECT.pfmType;
};

export const setTempateType = (template: string) => {
  USERSESSIONOBJECT.templateType = template;
};

export const getTemplateType = () => {
  return USERSESSIONOBJECT.templateType;
};

export const setAccounts = (account: any) => {
  localStorage.setItem('account', JSON.stringify(account));
  USERSESSIONOBJECT.accounts = account;
};
export const getAccounts = () => {
  return localStorage.getItem('account');
};
export const setData = (account: any) => {
  localStorage.setItem(
    'bankAccountsBalance',
    account.dataAttributes.CLOSING_BALANCE
  );
  localStorage.setItem(
    'account_profiles',
    JSON.stringify(account.dataAttributes.ACCOUNT_PROFILES)
  );
  localStorage.setItem(
    'total_accounts',
    account.dataAttributes.ACCOUNT_PROFILES.length
  );
  localStorage.setItem('data', JSON.stringify(account));
};
export const getBankAccountsBalance = () => {
  return getClosingBalance();
  return +(localStorage.getItem('bankAccountsBalance') ?? '0');
};
export const getAccountProfile = () => {
  return getBankOverallDetails();
  const accountProfiles: any = localStorage.getItem('account_profiles');
};
export const getData = () => {
  return localStorage.getItem('account');
};
export const getAccessToken = () => {
  return USERSESSIONOBJECT.accessToken;
};
export const getRefreshToken = () => {
  return USERSESSIONOBJECT.refreshToken;
};
export const areApprovedConsentsAvailable = () => {
  return USERSESSIONOBJECT.approvedConsentsAvailable;
};

export const getUserId = () => {
  return USERSESSIONOBJECT.userId;
};
export const setUserId = (userId: string) => {
  USERSESSIONOBJECT.userId = userId;
};
export const setAccessToken = (accessToken: string) => {
  USERSESSIONOBJECT.accessToken = accessToken;
};
export const setRefreshToken = (refreshToken: string) => {
  USERSESSIONOBJECT.refreshToken = refreshToken;
};
export const setIsApprovedConsentsAvailable = (
  approvedConsentsAvailable: boolean
) => {
  USERSESSIONOBJECT.approvedConsentsAvailable = approvedConsentsAvailable;
};

export const setAreApprovedConsentsAvailable = (
  approvedConsentsAvailable: boolean
) => {
  USERSESSIONOBJECT.approvedConsentsAvailable = approvedConsentsAvailable;
};

export const storeUserSessionObject = (userDetails: UserDetailsType) => {
  setAccessToken(userDetails.accessToken);
  setRefreshToken(userDetails.refreshToken);
  setUserId(userDetails.userId);
  setAreApprovedConsentsAvailable(userDetails.approvedConsentsAvailable);
};

export const setReferenceId = (referenceId: string) => {
  USERSESSIONOBJECT.referenceId = referenceId;
};

export const getReferenceId = () => {
  return USERSESSIONOBJECT.referenceId;
};
